module.exports = __webpack_public_path__ + "static/media/entrepreneur.6e68914a.png";